import { MenuFoldOutlined, UserOutlined } from "@ant-design/icons";
import { AiOutlineMenu } from "react-icons/ai";
import { Avatar, Button, Col, Dropdown, Layout, Row, Space } from "antd";
import { useLocation } from "react-router-dom";

import DateNavigator from "./DateNavigator";
import usePageHeader from "./usePageHeader";
import NotificationsDrawer from "../NotificationsDrawer";

const { Header } = Layout;

const PageHeader = ({ collapsed, setCollapsed }) => {
  const location = useLocation();
  const isBoard = location.pathname === "/" || location.pathname === "";

  const {
    ddItems,
    user,
    dashboardLayout,
    actionButtonsLeftJsx,
    actionButtonsRightJsx,
    dashboardSelectsJsx,
    dashboardTagsJsx,
    timezone,
    screens,
    onDateChange,
    toggleNotificationDrawer,
    isNotificationDrawerVisible,
  } = usePageHeader();

  const showTitleAbove = isBoard && !screens.lg && dashboardLayout?.isHeaderRequired;

  return (
    <>
      <NotificationsDrawer
        open={isNotificationDrawerVisible}
        onClose={toggleNotificationDrawer}
      />
      <Header className={`page-header${showTitleAbove ? ' page-header--board-mobile' : ''}`}>
        {/* Mobile OR Board only: facility name on its own full-width row */}
        {showTitleAbove && (
          <div className="page-header-board-title">
            <h1 className="font-monstserrat page-title m-0">
              {dashboardLayout.boardInfo?.facilityName?.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase())}{" "}
              {dashboardLayout?.pageTitle}
            </h1>
          </div>
        )}

        <Row className="flex-1" justify={"center"}>
          {/* left side */}
          <Col xs={14} lg={10} className="page-header-left">
            {!screens.lg && setCollapsed && (
              <Button
                type="text"
                className="hamburger-btn"
                icon={collapsed ? <AiOutlineMenu color="#363740" /> : <MenuFoldOutlined />}
                onClick={() => setCollapsed((c) => !c)}
              />
            )}
            {/* Title inline: desktop always, mobile only on non-board pages */}
            {dashboardLayout?.isHeaderRequired && (screens.lg || !isBoard) && (
              <h1 className="font-monstserrat page-title m-0">
                {dashboardLayout.boardInfo?.facilityName?.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase())}{" "}
                {dashboardLayout?.pageTitle}
              </h1>
            )}
            {dashboardSelectsJsx}
            {dashboardTagsJsx}
            {actionButtonsLeftJsx}
          </Col>

          {/* center side */}
          {screens.lg && (
            <Col span={4} className="page-header-center">
              {dashboardLayout?.boardInfo?.boardDate && (
                <DateNavigator
                  calendarDate={dashboardLayout?.boardInfo?.boardDate}
                  timezone={timezone}
                  onDateChange={onDateChange}
                />
              )}
            </Col>
          )}

          {/* right side */}
          <Col span={10} className="page-header-right">
            {actionButtonsRightJsx}
            <Dropdown
              menu={{
                items: ddItems,
              }}
              trigger={["click"]}
            >
              <Space className="cursor-pointer">
                <Avatar
                  size={"large"}
                  className="user-avatar"
                  icon={<UserOutlined className="text-medium" />}
                />
                <div className="user-info">
                  <h4>{user?.name}</h4>
                  <div className="role">{user?.role}</div>
                  {user?.role === "provider" && user?.userFacilityCode && (
                    <div className="facility-code">{user?.userFacilityCode}</div>
                  )}
                </div>
              </Space>
            </Dropdown>
          </Col>
        </Row>
      </Header>
    </>
  );
};

export default PageHeader;
